import React from "react";
import Laboratory from "../../../places/pages/Lab/Laboratory";
import AppLayoutAssistant from "../../../navigation/Layout/LayoutAssistant";

export default function AssistantAnalysisLabPage() {
  return <Laboratory LayoutComponent={AppLayoutAssistant} />;
}
